// About.jsx
import React, { useEffect, useState } from "react";
import { wp } from "../lib/wp";

const About = () => {
  const [aboutData, setAboutData] = useState(null);
  const [teamData, setTeamData] = useState(null);

  // NEW: modal state (founder)
  const [isFounderOpen, setIsFounderOpen] = useState(false);

  useEffect(() => {
    fetch(wp("/wp/v2/pages?slug=team"))
      .then((res) => res.json())
      .then((data) => setTeamData(data[0]));
  }, []);

  useEffect(() => {
    fetch(wp("/wp/v2/pages?slug=about"))
      .then((res) => res.json())
      .then((data) => setAboutData(data[0]));
  }, []);

  if (!aboutData) return <div className="p-6">Yükleniyor...</div>;

  // Modal içeriği
  const founderBioHtml = `
  <ul style="margin: 0; padding-left: 1.25rem; list-style: disc; color: #1f2937;">
    <li>
      <em style="font-style: italic;">2025 – Devam Ediyor</em>
      <strong style="padding: 0 0.5rem; font-weight: 600;">|</strong>
      İTÜ – İnşaat Projeleri Yönetimi Yüksek Lisans
    </li>
    <li>
      <em style="font-style: italic;">2017 – 2021</em>
      <strong style="padding: 0 0.5rem; font-weight: 600;">|</strong>
      Doğuş Üniversitesi – Mimarlık Bölümü 
      <span style="color: #6b7280;">(Onur Belgesi ile Mezuniyet)</span>
    </li>
    <li>
      <em style="font-style: italic;">2013 – 2017</em>
      <strong style="padding: 0 0.5rem; font-weight: 600;">|</strong>
      İbrahim Süheyla İzmirloğlu Fen Lisesi
    </li>
  </ul>
`;

  return (
    <div className="max-w-5xl mx-auto p-6 text-gray-800">
      <h2 className="text-3xl font-bold mb-4 text-center uppercase text-[#424197]">
        {aboutData.title.rendered}
      </h2>

      {/* Hakkımızda metni: iki yana yaslı */}
      <p
        className="text-base md:text-lg mb-8 leading-relaxed"
        style={{ textAlign: "justify" }}
      >
        {aboutData.about_main_text}
      </p>

      {/* Ekibimiz */}
      {teamData && (
        <div
          className={[
            "mt-12 relative rounded-2xl p-6",
            "border border-[#424197]",
            "shadow-[0_10px_25px_rgba(39,40,92,0.25),0_2px_6px_rgba(39,40,92,0.15)]",
            "transition-all duration-300 ease-out",
            "bg-[#F8F6ED]",
          ].join(" ")}
        >
          <h3 className="text-2xl text-center font-semibold mb-6 text-[#424197]">
            EKİP
          </h3>

          <div className="flex flex-wrap gap-6">
            {/* Üye 1 (Kurucu | Mimar) */}
            {teamData.ekip_uyesi_adi && (
              <div
                className={[
                  "relative bg-white p-4 rounded-xl",
                  "border border-[#424197]",
                  "shadow-[0_10px_25px_rgba(39,40,92,0.25),0_2px_6px_rgba(39,40,92,0.15)]",
                  "transition-all duration-300 ease-out",
                  "flex items-center gap-4",
                  "w-full sm:w-[calc(50%-12px)]",
                ].join(" ")}
              >
                <img
                  src={teamData.ekip_uyesi_fotografi}
                  alt={teamData.ekip_uyesi_adi}
                  className="w-20 h-20 object-cover rounded-full border border-gray-300"
                />
                <div className="flex-1">
                  <h3 className="text-xl font-semibold">
                    {teamData.ekip_uyesi_adi}
                  </h3>

                  {/* unvan satırı + mini buton */}
                  <div className="flex items-center gap-2">
                    <p className="text-sm text-gray-600">
                      {teamData.ekip_uyesi_meslegi /* "Kurucu | Mimar" */}
                    </p>

                    {/* MINI BİLGİ BUTONU */}
                    <button
                      type="button"
                      onClick={() => setIsFounderOpen(true)}
                      className="inline-flex items-center justify-center shrink-0
             h-6 px-2 rounded-md text-xs font-medium
             border border-[#424197] bg-[#424197] text-white
             hover:bg-transparent hover:text-[#252f91]
             focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-[#252f91]
             transition ml-2"
                      aria-label="Meryem B. Demiray hakkında bilgi"
                      title="Hakkında"
                    >
                      Hakkında
                    </button>
                  </div>
                </div>

                {/* zemine düşen gölge */}
                <div className="pointer-events-none absolute inset-x-10 -bottom-3 h-6 rounded-full bg-[#252f91]/30 blur-xl opacity-50"></div>
              </div>
            )}

            {/* Üye 2 */}
            {teamData.ekip_uyesi_2_adi && (
              <div
                className={[
                  "relative bg-white p-4 rounded-xl",
                  "border border-[#424197]",
                  "shadow-[0_10px_25px_rgba(39,40,92,0.25),0_2px_6px_rgba(39,40,92,0.15)]",
                  "transition-all duration-300 ease-out",
                  "flex items-center gap-4",
                  "w-full sm:w-[calc(50%-12px)]",
                ].join(" ")}
              >
                <img
                  src={teamData.ekip_uyesi_2_fotografi}
                  alt={teamData.ekip_uyesi_2_adi}
                  className="w-20 h-20 object-cover rounded-full border border-gray-300"
                />
                <div>
                  <h3 className="text-xl font-semibold">
                    {teamData.ekip_uyesi_2_adi}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {teamData.ekip_uyesi_2_meslegi}
                  </p>
                </div>
                <div className="pointer-events-none absolute inset-x-10 -bottom-3 h-6 rounded-full bg-[#27285C]/30 blur-xl opacity-50"></div>
              </div>
            )}

            {/* Üye 3 */}
            {teamData.ekip_uyesi_3_adi && (
              <div
                className={[
                  "relative bg-white p-4 rounded-xl",
                  "border border-[#424197]",
                  "shadow-[0_10px_25px_rgba(39,40,92,0.25),0_2px_6px_rgba(39,40,92,0.15)]",
                  "transition-all duration-300 ease-out",
                  "flex items-center gap-4",
                  "w-full sm:w-full md:w-1/2 mx-auto",
                ].join(" ")}
              >
                <img
                  src={teamData.ekip_uyesi_3_fotografi}
                  alt={teamData.ekip_uyesi_3_adi}
                  className="w-20 h-20 object-cover rounded-full border border-gray-300"
                />
                <div>
                  <h3 className="text-xl font-semibold">
                    {teamData.ekip_uyesi_3_adi}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {teamData.ekip_uyesi_3_meslegi}
                  </p>
                </div>
                <div className="pointer-events-none absolute inset-x-10 -bottom-3 h-6 rounded-full bg-[#27285C]/30 blur-xl opacity-50"></div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* --- MODAL: Meryem B. Demiray Hakkında --- */}
      {isFounderOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center"
          role="dialog"
          aria-modal="true"
        >
          {/* overlay */}
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => setIsFounderOpen(false)}
          />
          {/* dialog */}
          <div
            className="
              relative z-10
              w-[82%] sm:w-[85%] md:w-[720px] lg:w-[675px]
              max-h-[80vh] overflow-y-auto
              bg-white rounded-2xl border border-[#27285C] shadow-2xl
            "
          >
            {/* --- üst kısım: isim & unvan --- */}
            <div className="p-5 border-b border-gray-200 flex items-center justify-between">
              <div className="flex items-center gap-3 w-full sm:w-auto">
                {teamData?.ekip_uyesi_fotografi && (
                  <img
                    src={teamData.ekip_uyesi_fotografi}
                    alt={teamData?.ekip_uyesi_adi || "Meryem B. Demiray"}
                    className="w-12 h-12 rounded-full object-cover border"
                  />
                )}
                <div className="flex flex-col sm:flex-row sm:items-center sm:gap-2">
                  <div className="font-semibold text-[#27285C] leading-5">
                    {teamData?.ekip_uyesi_adi || "Meryem B. Demiray"}
                  </div>
                  <div className="text-sm text-gray-600 leading-5">
                    {teamData?.ekip_uyesi_meslegi || "Kurucu | Mimar"}
                  </div>
                </div>
              </div>
              <button
                onClick={() => setIsFounderOpen(false)}
                className="h-8 w-8 inline-flex items-center justify-center rounded-md border border-gray-300 hover:bg-gray-100"
                aria-label="Kapat"
                title="Kapat"
              >
                ✕
              </button>
            </div>

            {/* içerik */}
            <div className="p-5">
              <div
                className="
                  prose prose-sm max-w-none
                  text-[15px] sm:text-base
                  leading-6 sm:leading-7
                  break-words whitespace-normal
                  [&>ul]:pl-0 sm:[&>ul]:pl-6
                  [&>ul]:list-none sm:[&>ul]:list-disc
                  [&_li]:mb-2
                "
                dangerouslySetInnerHTML={{ __html: founderBioHtml }}
              />
            </div>

            {/* footer yok */}
          </div>
        </div>
      )}
    </div>
  );
};

export default About;
